<span class="tag">
  <span
    #tag
    class="label-base label"
    [class]="size"
    (click)="clickTag()"
    [ngClass]="{ clickable: isClickable, 'inactive-color': !isClickable && !tagColor, draggable: isDraggable, removable: isRemovable }"
    [style.background-color]="!isTagInteractive && tagColor"
    [style.color]="!isTagInteractive && tagColor ? 'white' : null"
  >
    <div class="inner">
      <!-- Drag Icon -->
      <div *ngIf="isDraggable" class="icon2-x16-micro-handle drag-icon label-xs"></div>

      <!-- Label Text -->
      <div
        *ngIf="label"
        class="label-text"
        [ngClass]="{ 'label-xs-semibold': size === tagSize.EXTRA_SMALL, 'label-sm-semibold': size === tagSize.SMALL }"
      >
        <i [class]="icon" class="mr-2" *ngIf="icon"></i>
        {{ label }}
      </div>

      <!-- Template -->
      <div *ngIf="tagContentTmp" class="template-text label-sm-semibold-single">
        <ng-container *ngTemplateOutlet="tagContentTmp"> </ng-container>
      </div>

      <!-- Tag Relation -->
      <div *ngIf="isColorsVisible" class="color-container">
        <div *ngFor="let color of colors" class="tag-relation-color" [style.background-color]="color"></div>
      </div>

      <!-- Tag Counter -->
      <div *ngIf="isTagCounterVisible" class="counter label-xs-semibold" [class.counter-white]="!isTagInteractive && tagColor">
        {{ tagCounter }}
      </div>

      <!-- Close Icon -->
      <span *ngIf="isRemovable" class="icon2-x16-micro-close remove-icon" (click)="closeTag($event)"></span>
    </div>
  </span>
</span>
